<template>
  <div class="searcher">
      <input
        v-if="showCategory"
        v-model="category"
        type="text"
        class=" form-control"
        placeholder="category"
        
        @keydown.enter="handleClickSearch"
      />
      <input
        v-model="keyword"
        type="text"
        class=" form-control"
        placeholder="keyword"
        
        @keydown.enter="handleClickSearch"
      />
        <button class="btn btn-primary" type="button" @click="handleClickSearch">搜索</button>
  </div>
</template>

<script>
export default {
  name: "Searcher",
  props: [
    'showCategory'
  ],
  data: function() {
    return {
      keyword: "",
      category:"",
    };
  },
  methods: {
    handleClickSearch(){
      this.$emit("search",{keyword:this.keyword,category:this.category});
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.searcher {
  margin:20px auto;
  max-width: 300px;
  width:80%;

}
.searcher>button{
  width:100%;
}
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
a {
  color: #42b983;
}
</style>
